<template>
  <div>
    <div class="field">
      <label class="label">{{ $t("service url") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.service_url"
          placeholder="https://us.sms.api.sinch.com/xms/v1/"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-server"></i>
        </span>
      </p>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("service plan id") }}</label>
          <p class="control is-expanded has-icons-left">
            <input type="text" class="input" v-model="meta.service_plan_id" />
            <span class="icon is-small is-left">
              <i class="fa fa-building"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("api token") }}</label>
          <p class="control is-expanded has-icons-left">
            <input type="text" class="input" v-model="meta.api_token" />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("sinch virtual number") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.sinch_virtual_number"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-phone"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("default phone country code") }}</label>
          <div class="select">
            <select v-model="meta.default_phone_country_code" class="">
              <option value="">{{ $t("select one") }}</option>
              <option value="+502">+502 {{ $t("guatemala") }}</option>
              <option value="+503">+503 {{ $t("el salvador") }}</option>
              <option value="+504">+504 {{ $t("honduras") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        service_url: "",
        campaign: "",
        agent: "",
        origin: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
    clear() {
      this.meta = {
        service_url: "",
        campaign: "",
        agent: "",
        origin: "",
      };
    },
  },
};
</script>
